import * as React from 'react';
import { HTMLAttributes } from 'react';
import cn from 'classnames';

import '@mos-utils/css/lib/typography/Link.css';

function Link({ className, children, ...props }: Props) {
  return (
    <a {...props} className={cn('mos-link', className)}>
      {children}
    </a>
  );
}

interface Props extends HTMLAttributes<HTMLAnchorElement> {}

export default Link;
